import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import ReactPaginate from 'react-paginate';
import InvoiceList from './InvoiceList';
import JobFilter from '../Jobs/JobsTable/JobFilter';
import FormSelect from 'react-select';
import InvoiceFilter from './InvoiceFilter';
import ProduceInvoiceModal from './ProduceInvoiceModal';

export class CustomerInvoices extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            offset: 0,
            invoice_term: 'monthly',
            search: '',
            purchase_numbers: [],
            showProduceInvoiceModal: false,
        };
    }

    handlePurchaseNumberInput = (e) => {
        let value = e.target.value;
        let invoiceId = e.target.name;

        let purchase_numbers = [...this.state.purchase_numbers];
        purchase_numbers.push({ [invoiceId]: value });

        this.setState(
            {
                purchase_numbers: purchase_numbers,
            },
            () => console.log(this.state)
        );
    };

    loadInvoicesFromServer() {
        $.ajax({
            url: this.props.url,
            data: {
                limit: this.props.perPage,
                offset: this.state.offset,
                invoice_term: this.state.invoice_term,
                search: this.state.search,
            },
            dataType: 'json',
            type: 'GET',
            success: (data) => {
                this.setState({
                    data: data.invoices,
                    pageCount: Math.ceil(data.total / this.props.perPage),
                });
            },

            error: (xhr, status, err) => {
                console.log(this.props.url, status, err.toString());
            },
        });
    }

    componentDidMount() {
        this.loadInvoicesFromServer();
    }

    handlePageClick = (data) => {
        let selected = data.selected;
        let offset = Math.ceil(selected * this.props.perPage);

        this.setState({ offset: offset }, () => {
            this.loadInvoicesFromServer();
        });
    };

    handleClick = (url) => {
        window.location.href = url;
    };

    handleChange = (e) => {
        this.setState({
            invoice_term: e.value,
            offset: 0,
        });
    };

    handleSearchInput = (e) => {
        this.setState({
            search: e.target.value,
            offset: 0,
        });
    };

    handleSearchClick = () => {
        this.loadInvoicesFromServer();
    };

    handleFilterClick = (e) => {
        this.setState({
            invoice_type: e,
        });
    };

    handlePoChange = (e, identifier) => {
        let value = e.target.value;
        console.log(identifier);
        let invoices = [...this.state.data];

        let invoice = invoices.find((invoice) => {
            return invoice.invoice_identifier === identifier;
        });

        invoice.po_number = value;

        this.setState(
            {
                data: invoices,
            },
            () => console.log(this.state.data)
        );
    };

    savePoNumber = (identifier) => {
        this.setState({
            loading: identifier,
        });

        let invoice = this.state.data.find((invoice) => {
            return invoice.invoice_identifier === identifier;
        });
        console.log(identifier, invoice.po_number);
        $.ajax({
            url: this.props.savePOUrl,
            data: { identifier: identifier, po_number: invoice.po_number },
            dataType: 'json',
            type: 'POST',
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            },
            success: (data) => {
                toastr.success('PO Number successfully Saved');
                this.setState({
                    loading: null,
                });
            },
            error: (xhr, status, err) => {
                toastr.error('There was a problem, please try again');
                this.setState({
                    loading: null,
                });
            },
        });
    };

    showProduceInvoiceModal = () => {
        this.setState({
            showProduceInvoiceModal: true,
        });
    };

    hideProduceInvoiceModal = () => {
        this.setState({
            showProduceInvoiceModal: false,
        });
    };

    render() {
        return (
            <div>
                <div className="row pt-4">
                    <div className="col-12">
                        <div className="cw-bg-grey py-1 d-flex justify-content-between align-items-center">
                            <div>
                                <h6 className="text-white py-2 pl-2">{this.state.invoice_term} Invoices</h6>
                            </div>
                            <div className="pr-2">
                                <InvoiceFilter
                                    options={this.props.filterOptions}
                                    value={this.state.invoice_term}  
                                    onChange={this.handleChange}
                                    handleSearchInput={this.handleSearchInput}
                                    search={this.state.search}
                                    handleSearchClick={this.handleSearchClick}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                <InvoiceList
                    data={this.state.data}
                    downloadUrl={this.props.downloadUrl}
                    providerInvoice={this.props.providerInvoice}
                    onPoChange={this.handlePoChange}
                    savePoNumber={this.savePoNumber}
                    invoiceUrl={this.props.invoiceUrl}
                />
                <ReactPaginate
                    previousLabel={'previous'}
                    nextLabel={'next'}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={this.state.pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={this.handlePageClick}
                    containerClassName={'pagination'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                />
                <div className="row pt-4">
                    <div className="col-12 transform-text">
                        <button
                            className="btn btn-cw-green"
                            onClick={this.showProduceInvoiceModal}
                            style={{ marginTop: 20, marginLeft: 15 }}
                        >
                            Produce missing invoices
                        </button>
                    </div>
                </div>
                {this.state.showProduceInvoiceModal && (
                    <ProduceInvoiceModal
                        show={true}
                        onHide={this.hideProduceInvoiceModal}
                        term={this.state.invoice_term}
                        type={this.props.providerInvoice ? 'provider' : 'customer'}
                        termLabel={this.props.filterOptions?.find((o) => o.value === this.state.invoice_term)?.label}
                    />
                )}
            </div>
        );
    }
}

if (document.getElementById('customer-invoices')) {
    let element = document.getElementById('customer-invoices');

    ReactDOM.render(
        <CustomerInvoices
            url={element.dataset.url}
            perPage={element.dataset.per_page}
            downloadUrl={element.dataset.download_url}
            filterOptions={JSON.parse(element.dataset.filter_options)}
            providerInvoice={element.dataset.provider_invoice === '1'}
            savePOUrl={element.dataset.po_url}
            invoiceUrl={element.dataset.invoice_url}
        />,
        element
    );
}

export default CustomerInvoices;
